import { combineReducers } from "redux";

import user from "./user";
import overlay from "./overlay";
import tasks from "./tasks";
import banners from "./banners";
import recurringTasks from "./recurringTasks";
import admin from "./admin";
import about from "./about";
import session from "./session";
import messages from "./messages";
import activities from "./activities";

export default combineReducers({
  user,
  overlay,
  tasks,
  banners,
  recurringTasks,
  admin,
  about,
  session,
  messages,
  activities,
});
